<div [ngClass]="{'is-collapsed':isCollapsed}" class="tab-switcher h-100 d-flex flex-column py-4 position-relative ">
    <ul class="d-flex gap-1 flex-column nav-tabs flex-fill h-0 overflow-auto scrollbar-width-none flex-nowrap" ngbNav #nav="ngbNav" [(activeId)]="activeTab"
        (activeIdChange)="tabChanged(activeTab)">
        <li *ngFor="let tab of tabs" [ngbNavItem]="tab.id" class="w-100">
            <a draggable="false" ngbNavLink>
                <span class="d-flex justify-content-center">{{ tab.label ? tab.label : tab.name }}</span>
                <svg class="downArrow" xmlns="http://www.w3.org/2000/svg" width="10.552" height="5.276"
                    style="transform: rotate(-90deg);" viewBox="0 0 10.552 5.276">
                    <path id="Path_1294" data-name="Path 1294" d="M1298.971-743.028l5.276,5.276,5.276-5.276Z"
                        transform="translate(-1298.971 743.028)" fill="#7C89A4">
                    </path>
                </svg>
            </a>
            <ng-template ngbNavContent>
                <ng-container *ngComponentOutlet="tab.component"></ng-container>
            </ng-template>
        </li>
        
    </ul>

        <div (click)="toggleSidebar()" class="cursorPointer translate-middle position-absolute tab-switcher-label w-auto top-50"
            style="right: -16px;">
            <svg class="cursorPointer" xmlns="http://www.w3.org/2000/svg" width="19" height="97" viewBox="0 0 19 97">
                <g id="Group_50372" data-name="Group 50372" transform="translate(0.522)">
                    <rect id="Rectangle_27648" data-name="Rectangle 27648" width="19" height="97" rx="9"
                        transform="translate(-0.522)" fill="#4f39cd" />
                    <path id="Path_36997" data-name="Path 36997" d="M0,4.264,4.264,0,8.527,4.264"
                        transform="translate(11.241 7.758) rotate(90)" fill="none" stroke="#fff" stroke-linecap="round"
                        stroke-linejoin="round" stroke-width="1.2" />
                </g>
            </svg>
            <svg class="position-absolute cursorPointer mt-1 is-collapsed-icon start-0" xmlns="http://www.w3.org/2000/svg" height="20px"
                viewBox="0 -960 960 960" width="20px" fill="#FFFFFF">
                <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
            </svg>
            <label [ngStyle]="{ right: (right ?? -20) + 'px' }"  class="f-10 m-0 label font-semibold cursorPointer top-50 position-absolute text-white" for="label">{{label}}</label>
        </div>
</div>